export class StartSparkJobInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sparkEngineId",
            "baseName": "sparkEngineId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "directParams",
            "baseName": "directParams",
            "type": "StartSparkJobDirectParams",
            "format": ""
        },
        {
            "name": "templateParams",
            "baseName": "templateParams",
            "type": "StartSparkJobTemplateParams",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StartSparkJobInput.attributeTypeMap;
    }
    constructor() {
    }
}
